import { canSaveToLibrary, isStaff } from '../../../utils/permissions';
import { Divider } from 'antd';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import InputComponent from '../../common/InputComponent/InputComponent';
import { Icon } from '../../icon/icon';
import './HeaderDesign.scss';
import ButtonIconGhostLarge from '../../common/ButtonIconGhost/ButtonIconGhostLarge';
import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import { useContext, useEffect, useState } from 'react';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import { Link } from 'react-router-dom';
import Tag from '../../common/Tag/Tag';
import { Popover } from 'antd';
import { useTranslation, Trans } from 'react-i18next';
import Transition from '../../transition/transition';
import ExampleDesignRecommend from '../../../pages/DesignerPage/components/ExampleDesignRecommend/ExampleDesignRecommend';
import { useSelector } from 'react-redux';
import { Row } from 'antd/es';
import { Col } from 'antd/es';
import {
  lockMessage,
  unlockMessage,
} from '../../../utils/messages/messageLock';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import ButtonSecondarySmall from '../../common/ButtonSecondary/ButtonSecondarySmall';
import RenderPopup from './RenderPopup';

const HeaderDesign = () => {
  const {
    sceneManager,
    handleSaveAllDesign,
    setNameDesign,
    nameDesign,
    setShowCabinetTrimView,
    setOpenSaveLibraryModal,
    handleUpdateDesign,
    openExampleRecommend,
    setOpenExampleRecommend,
    designId,
    isDesignLibrary,
  } = useContext(DesignerPageContext);
  const { t } = useTranslation();

  const { user } = useSelector(state => state.auth);
  const [open, setOpen] = useState(false);

  const [showTransition, setShowTransition] = useState(false);
  const [showShortcut, setShowShortcut] = useState(false);

  const shortcuts = [
    {
      icon: <Icon.ICDataCheck />,
      label: t('Select multiple modules at once.'),
      shortcut: 'Shift + Click',
    },
    {
      icon: <Icon.IC360 />,
      label: t('Rotate Module 90°'),
      shortcut: 'R',
    },
    {
      icon: <Icon.ICDelete />,
      label: t('Delete Module'),
      shortcut: 'Delete ' + t('or') + ' Backspace',
    },
    {
      icon: <Icon.ICDoorSplash />,
      label: t('Hide/Show Door'),
      shortcut: 'H',
    },
    {
      icon: <Icon.ICRuler />,
      label: t('Measure overall dimensions'),
      shortcut: 'Alt + D ' + t('or') + ' Option + D',
    },
    {
      icon: <Icon.ICMeasure />,
      label: t('Measure distance to wall'),
      shortcut: 'Alt + Q ' + t('or') + ' Option + Q',
    },
  ];

  useEffect(() => {
    if (!user) {
      lockMessage(); // 🛑 Chặn toàn bộ message error
    } else {
      unlockMessage(); // ✔️ Bật lại message khi modal đóng
    }
    return () => {
      // Đảm bảo message luôn được mở lại khi component unmount
      unlockMessage();
    };
  }, [user]);

  return (
    <>
      <header className="designer-header">
        <a
          href={'/'}
          className="flex items-center"
          style={{
            width: '130px',
            height: '40px',
            aspectRatio: '139/40',
          }}
        >
          <img
            src="/assets/logo/new_logo_fitta.png"
            alt=""
            className="w-full"
          />
        </a>
        <div className="title">
          {canSaveToLibrary(user) ? (
            <span className="text-title-medium">
              {getValueFromString(nameDesign)}
            </span>
          ) : (
            <InputComponent
              value={nameDesign}
              style={{
                border: 'none',
                width: 'fit-content',
                maxWidth: '300px',
              }}
              onChange={e => {
                const val = e?.target ? e.target.value : e; // hỗ trợ cả 2 kiểu onChange
                setNameDesign(val);
              }}
              styles={{
                input: {
                  width: 'fit-content',
                  fontWeight: '600',
                  maxWidth: '300px',
                  fieldSizing: 'content',
                  fontSize: '18px',
                  height: '24px',
                },
              }}
              placeholder={'Untitled'}
              suffix={
                <span style={{ width: '24px', height: '24px' }}>
                  <Icon.ICEditText />
                </span>
              }
            />
          )}
        </div>
        <div className="header-actions">
          <div className="Estimated-cost">
            <span className="text-label-small" style={{ color: '#818589' }}>
              {t('Estimated cost')}
            </span>
            <div
              className="flex items-center"
              style={{ gap: '8px', color: '#5A5D60' }}
            >
              <Popover
                getPopupContainer={() => document.body}
                destroyOnHidden={true}
                trigger="hover"
                styles={{
                  body: { width: '280px', maxHeight: '148px' },
                }}
                title={
                  <div className="flex flex-col p-[12px] justify-start items-start self-stretch gap-[12px]">
                    <span className="text-title-small">
                      {t('Estimated cost')}
                    </span>
                    <span className="text-body-small">
                      <Trans
                        i18nKey="Excludes trims and auxiliary boards. The exact price will be shown at the <strong>Design Completion</strong> step."
                        components={{ strong: <strong /> }}
                      />
                    </span>
                  </div>
                }
                content={
                  <div className="flex p-[12px] pt-[8px] justify-end items-center gap-[8px] self-stretch">
                    <ButtonSecondarySmall title={t('I got it')} />
                  </div>
                }
                classNames={{
                  body: '!p-0 overflow-hidden [&_.ant-popover-title]:mb-0',
                }}
              >
                <span className="text-title-large flex items-center gap-4">
                  <div className="flex gap-[4px] items-center justify-center">
                    <span
                      id="estimated-cost"
                      className="text-title-medium"
                    ></span>
                    <span
                      id="estimated-cost-special"
                      className="text-title-medium text-Accents-Red"
                    ></span>
                  </div>
                </span>
              </Popover>

              {process.env.NODE_ENV === 'development' || isStaff(user) ? (
                <Tag
                  onClick={() => setShowTransition(true)}
                  style={{ background: '#F5F6F6' }}
                  label={
                    <span className="w-14 h-14 flex">
                      <Icon.ICDesign />
                    </span>
                  }
                />
              ) : (
                <></>
              )}

              <Popover
                getPopupContainer={() => document.body}
                destroyOnHidden={true}
                content={<RenderPopup setOpen={setOpen} />}
                trigger="click"
                styles={{
                  body: { width: '520px', maxHeight: '720px' },
                }}
                classNames={{ body: '!p-0 overflow-hidden' }}
                title={
                  <div
                    className="flex p-16 justify-between items-center self-stretch"
                    style={{ borderBottom: '1px solid #E6E7E7' }}
                  >
                    <span className="text-title-large">{t('Products')}</span>
                    <ButtonIconOutlineMedium
                      icon={<Icon.ICClose />}
                      onClick={() => setOpen(false)}
                    />
                  </div>
                }
                open={open}
                onOpenChange={setOpen}
              >
                <ButtonIconGhostSmall
                  icon={<Icon.ICList />}
                  style={{ border: '1px solid #CFD1D2 ' }}
                />
              </Popover>
            </div>
          </div>

          {!canSaveToLibrary(user) && (
            <>
              <Divider type="vertical" style={{ height: '40px', margin: 0 }} />
              <ButtonPrimaryLarge
                title={t('Complete & save')}
                onClick={() => {
                  setShowCabinetTrimView(true);
                  handleSaveAllDesign({ complete: true });
                }}
                preIcon={<Icon.ICArrowForward />}
              />
            </>
          )}

          <Divider type="vertical" style={{ height: '40px', margin: 0 }} />
          {!canSaveToLibrary(user) && (
            <>
              <ButtonIconGhostLarge
                icon={<Icon.ICDresses />}
                onClick={() => {
                  setOpenExampleRecommend(true);
                }}
              />
            </>
          )}
          <Popover
            getPopupContainer={() => document.body}
            content={
              <>
                {shortcuts.map((item, index) => (
                  <Row gutter={[0, 0]} key={index}>
                    <Col span={12} style={{ border: '1px solid black ' }}>
                      <div className="flex px-24 py-12 items-center gap-16 h-48">
                        <span className="flex w-24 h-24">{item.icon}</span>
                        <span className="text-body-medium">{item.label}</span>
                      </div>
                    </Col>
                    <Col span={12} style={{ border: '1px solid black ' }}>
                      <div className="flex p-12 justify-center items-center gap-8 self-stretch">
                        <span className="text-body-medium">
                          {item.shortcut}
                        </span>
                      </div>
                    </Col>
                  </Row>
                ))}
              </>
            }
            trigger="click"
            styles={{
              body: { width: '607px', maxHeight: '331px' },
            }}
            classNames={{ body: 'p-16 overflow-hidden' }}
            open={showShortcut}
            onOpenChange={setShowShortcut}
          >
            <ButtonIconGhostLarge icon={<Icon.ICShortcut />} />
          </Popover>
          <ButtonIconGhostLarge
            icon={<Icon.ICSave />}
            onClick={() => {
              sceneManager.exportFullDrawingToPDF('out.pdf', {
                frontOffsetDeg: 90,
              });
            }}
          />

          {canSaveToLibrary(user) && (
            <>
              <ButtonPrimaryLarge
                title={!isDesignLibrary ? t('Save design') : t('Update design')}
                posIcon={<Icon.ICProcurement />}
                onClick={() => {
                  setOpenSaveLibraryModal(true);
                }}
              />
              {designId && !isDesignLibrary && (
                <ButtonPrimaryLarge
                  title={t('Update design')}
                  posIcon={<Icon.ICProcurement />}
                  onClick={() => handleUpdateDesign()}
                />
              )}
            </>
          )}
        </div>
      </header>
      <Transition
        open={showTransition}
        onClose={() => setShowTransition(false)}
        sceneManager={sceneManager}
      />
      <ExampleDesignRecommend
        open={openExampleRecommend}
        onClose={() => setOpenExampleRecommend(false)}
      />
    </>
  );
};

export default HeaderDesign;
